'use client';

import React, { useState, useEffect } from 'react';
import { Sidebar } from '@/components/dashboard/layout/Sidebar';
import { Header } from '@/components/dashboard/layout/Header';

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [businessSlug, setBusinessSlug] = useState('juanrojas');
  const [businessName, setBusinessName] = useState('Juan Rojas');

  useEffect(() => {
    fetch('/api/business')
      .then((r) => r.json())
      .then((data) => {
        if (data.success && data.business) {
          if (data.business.slug) setBusinessSlug(data.business.slug);
          if (data.business.name) setBusinessName(data.business.name);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white flex font-[family-name:var(--font-plus-jakarta)] antialiased text-[#111827]">
      {/* Sidebar estilo fondo blanco con acentos turquesa #00A896 */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        businessSlug={businessSlug}
        businessName={businessName}
      />

      {/* Contenedor Principal */}
      <div className="flex-1 flex flex-col min-w-0 min-h-screen bg-white">
        {/* Header superior de 64px con BranchSelector y accesos rápidos */}
        <Header
          onOpenSidebar={() => setSidebarOpen(true)}
          businessSlug={businessSlug}
        />

        {/* Canvas de Contenido con fondo blanco y espaciado ergonómico */}
        <main className="flex-1 p-4 md:p-8 overflow-y-auto bg-white">
          {children}
        </main>
      </div>
    </div>
  );
}
